<template>
    <section>
		<v-alert
		v-if="display_alert"
		:type="alert_type"
		dismissible
		>
		{{ alert_text }}
		</v-alert>

		<v-btn
			v-if="watermark_visible"
			color="primary"
			:to="{name: 'Buy', params: { request_id: request_id }}"
			style="margin: 10px;"
		>
		Buy without Watermark
		</v-btn>
		<v-btn
			color="primary"
			:href="full_result_url"
			style="margin: 10px;"
			download
		>
		Download
		</v-btn>
		<v-btn
			color="primary"
			style="margin: 10px;"
			@click="share_button_clicked"
		>
		Share
		</v-btn>
		<div v-if="display_share_link">
			<v-text-field
				v-model="full_result_url"
				label="Link"
			></v-text-field>
			<v-btn
				outlined
				@click="copyText">
				Copy
			</v-btn>
		</div>
		<div>
			<video controls>
				<source :src="full_result_url" type="video/mp4">
				Your browser does not support the video tag.
			</video>
		</div>
    </section>
</template>

<script>
export default {
  props: ['user', 'api_prefix', 'watermark_visible', 'full_result_url', 'request_id'],
    data() {
        return {
            web_share_available: false,
          	display_share_link: false,
			display_alert: false,
			alert_type: "success",
			alert_text: null,
        }
    },
    methods:
    {
		share_button_clicked()
      	{
			if (this.web_share_available==true)
			{
				navigator.share({
					title: 'Paintera video',
					text: 'Check out this video',
					url: this.full_result_url,
				})
				.then(() => console.log('Successful share'))
				.catch((error) => console.log('Error sharing', error));
			}
			else
			{
				//display the link in a text box with a copy button
				this.display_share_link = true
			}
      	},
		copyText()
		{
			navigator.clipboard.writeText(this.full_result_url);
			this.alert_text = "Your link has been copied"
			this.display_alert = true
		},
    },
    created()
    {
        if (navigator.share) 
      	{
        	this.web_share_available = true
      	}
    }
};
</script>

<style scoped>

</style>
